import Immutable from 'immutable';
import { createSelector } from 'reselect';
import config from '../../config';

import {
  fetchCampaignDetails,
} from '../../redux/modules/campaignList';

// Action Types
const SEARCH = 'campaign/SEARCH';
const SEARCH_SUCCESS = 'campaign/SEARCH_SUCCESS';
const SEARCH_FAIL = 'campaign/SEARCH_FAIL';
const LOAD = 'campaign/LOAD';
const LOAD_SUCCESS = 'campaign/LOAD_SUCCESS';
const LOAD_ADD_SUCCESS = 'campaign/LOAD_ADD_SUCCESS';
const LOAD_FAIL = 'campaign/LOAD_FAIL';
const LOAD_UPDATE_SUCCESS = 'campaign/LOAD_UPDATE_SUCCESS';
const LOAD_ADD_QUS_SUCCESS = 'campaign/LOAD_ADD_QUS_SUCCESS';
const LOAD_UPDATE_QUS_SUCCESS = 'campaign/LOAD_UPDATE_QUS_SUCCESS';
const HIDE_ERROR_MESSAGE = 'campaign/HIDE_ERROR_MESSAGE';
const LOAD_UPDATE_FAIL = 'campaign/LOAD_UPDATE_FAIL';
const LOAD_UPDATE_FAIL_PROFILE_PIC = 'campaign/LOAD_UPDATE_FAIL_PROFILE_PIC';
const LOAD_UPDATE_SUCCESS_PROFILE_PIC = 'campaign/LOAD_UPDATE_SUCCESS_PROFILE_PIC';
export const NEW_CAMPAIGN_ADD_CLICK = 'campaign/NEW_CAMPAIGN_ADD_CLICK';
export const CAMPAIGN_DELETE_SHOW = 'campaign/CAMPAIGN_DELETE_SHOW';
export const CAMPAIGN_DELETE_HIDE = 'campaign/CAMPAIGN_DELETE_HIDE';
export const CAMPAIGN_ADD_HIDE = 'campaign/CAMPAIGN_ADD_HIDE';

const initialState = Immutable.fromJS({
  Campaigns: null,
  Campaign: null,
  searchCampaigns: null,
  loading: false,
  errorMessage: null,
  shouldShowAddCampaignModal: false,
  shouldShowDeleteCampaignModal: false,
  campaignToDelete: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH:
      return state
        .set('searching', true);

    case SEARCH_FAIL:
      return state
        .set('searching', false)
        .set('errorMessage', action.errorMessage);
    case SEARCH_SUCCESS:
      return state
      .set('searching', false)
      .set('searchCampaigns', action.searchCampaigns);

    case LOAD:
      return state
        .set('loading', true);

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('Campaigns', action.Campaigns);      

    case LOAD_ADD_SUCCESS:
      return state
        .set('loading', false)
        .set('Campaign', action.result);

    case LOAD_ADD_QUS_SUCCESS:
      return state
        .set('loading', false)

    case LOAD_UPDATE_QUS_SUCCESS:
      return state
        .set('loading', false);

    case LOAD_UPDATE_SUCCESS:
      return state
        .set('loading', false);

    case HIDE_ERROR_MESSAGE:
      return state
        .set('errorMessage', null);

    case NEW_CAMPAIGN_ADD_CLICK: {
      return state
        .set('shouldShowAddCampaignModal', true);
    }

    case CAMPAIGN_DELETE_SHOW: {
      return state
        .set('shouldShowDeleteCampaignModal', true)
        .set('campaignToDelete', action.payload)
    }

    case CAMPAIGN_DELETE_HIDE: {
      return state
        .set('shouldShowDeleteCampaignModal', false);
    }

    case CAMPAIGN_ADD_HIDE: {
      return state
        .set('shouldShowAddCampaignModal', false);
    }

    default:
      return state;
  }
}

// Action Creators
export function addNewCampaign() {
  return {
    type: NEW_CAMPAIGN_ADD_CLICK,
  };
}

export const showDeleteCampaignModal = (campaignId) => {
  return {
    type: CAMPAIGN_DELETE_SHOW,
    payload: campaignId,
  };
};

export const hideDeleteCampaignModal = () => {
  return {
    type: CAMPAIGN_DELETE_HIDE,
  };
};

export const hideAddCampaignModal = () => {
  return {
    type: CAMPAIGN_ADD_HIDE,
  };
};

// Actions
export const getCampaigns = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get('/campaign/all');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Campaigns: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateCampaign = (data, campaignLink) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
   try {
    const res = await api.put('/campaign', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(fetchCampaignDetails(campaignLink));
    dispatch({ type: LOAD_UPDATE_SUCCESS });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateCampaignLogo = (data, campaignLink) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
   try {
    const res = await api.put('/campaign', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(fetchCampaignDetails(campaignLink));
    dispatch({ type: LOAD_UPDATE_SUCCESS });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateCampaignProfileData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
   try {
    const res = await api.put('/campaign', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_UPDATE_SUCCESS });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateCampaignProfilePic = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
   try {
    const res = await api.post('/campaign/s3/imageBody', { data });
    if (res.message) {
      dispatch({ type: LOAD_UPDATE_FAIL_PROFILE_PIC, errorMessage: res.message });
      return;
    }
    return res;
    dispatch({ type: LOAD_UPDATE_SUCCESS_PROFILE_PIC });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_FAIL, errorMessage: error });
  }
};

export const updateCampaignLogoPic = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
   try {
    const res = await api.post('/campaign/s3/logoBody', { data });
    if (res.message) {
      dispatch({ type: LOAD_UPDATE_FAIL_PROFILE_PIC, errorMessage: res.message });
      return;
    }
    return res;
    dispatch({ type: LOAD_UPDATE_SUCCESS_PROFILE_PIC });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_FAIL, errorMessage: error });
  }
};

export const addCampaign = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/campaign', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch(getCampaigns());
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
    throw error;
  }
};

export const addCampaignQuestion = (data, campaignLink) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post('/campaign/question', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_QUS_SUCCESS, result: res });
    dispatch(fetchCampaignDetails(campaignLink));
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateCampaignQuestion = (data, campaignLink) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/campaign/question', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_UPDATE_QUS_SUCCESS, result: res });
    dispatch(fetchCampaignDetails(campaignLink));
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteCampaignQuestion = (data, campaignLink) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/campaign/question', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_UPDATE_QUS_SUCCESS, result: res });

    dispatch(fetchCampaignDetails(campaignLink));
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteCampaign = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/campaign', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    //dispatch({ type: LOAD_UPDATE_QUS_SUCCESS, result: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const hideErrorMessage = () => async(dispatch) => {
  dispatch({type: HIDE_ERROR_MESSAGE});
}

export const hideError = () => {
  return {
    type: HIDE_ERROR_MESSAGE,
  };
}

export const updateCampaignFilter = (data) => (dispatch, getState) => {
  const campaigns = getState().get('campaign').get('Campaigns');
  const index = campaigns.findIndex(campaign => campaign.id === data.campaignId);
  campaigns[index].plugin = data;
  dispatch({ type: 'LOAD_SUCCESS',  Campaigns: campaigns })
}

export const getSearchCampaigns = (data) => async (dispatch, getState, api) => {

  dispatch({ type: SEARCH });

  try {
    const res = await api.post('/campaign/search' , { data });
    if (res.message) {
      dispatch({ type: SEARCH_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEARCH_SUCCESS, searchCampaigns: res });
  } catch (error) {
    dispatch({ type: SEARCH_FAIL, errorMessage: error });
  }
};

export const addNewCampaignWithType = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post(config.endpoints.campaignCreate, { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return res;
    }
    await dispatch(getCampaigns());
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const validadeCustomDomain = (domain) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.post('/custom-domain/check', { data: { domain } });
    if (res !== null) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const saveCustomDomain = (campaignId, domain) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.post(`/custom-domain/${campaignId}`, { data: { domain } });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

// Selectors
export const getCampaignState = createSelector(
  state => state.get('campaign'),
  campaignNode => campaignNode,
);

export const getAreCampaignsLoading = createSelector(
  getCampaignState,
  campaign => campaign.get('loading'),
);

export const getAllCampaignsForUser = createSelector(
  getCampaignState,
  campaign => campaign.get('Campaigns') || [],
);

export const getHasCampaigns = createSelector(
  getAllCampaignsForUser,
  campaigns => campaigns.length > 0,
);

export const getCampaignByCampaignLink = createSelector(
  (state, campaignLink) => getAllCampaignsForUser(state, campaignLink),
  (state, campaignLink) => campaignLink,
  (campaigns, campaignLink) => campaigns.find(c => c.campaignLink === campaignLink),
);

export const getShouldShowAddCampaignModal = createSelector(
  getCampaignState,
  campaignState => campaignState.get('shouldShowAddCampaignModal'),
);

export const getShouldShowDeleteCampaignModal = createSelector(
  getCampaignState,
  campaignState => campaignState.get('shouldShowDeleteCampaignModal'),
);

export const getCampaignToDelete = createSelector(
  getCampaignState,
  campaignState => campaignState.get('campaignToDelete'),
);

export const getCampaignErrorMessage = createSelector(
  getCampaignState,
  campaignState => campaignState.get('errorMessage'),
);

export const getCampaignNamesForFilter = createSelector(
  getAllCampaignsForUser,
  campaigns => campaigns.map(c => ({ label: c.name, value: c.id })),
);



// WEBPACK FOOTER //
// ./src/redux/modules/campaign.js